<template>
  <div class="tab-container">
    <el-tabs style='margin-top:15px;' v-model="activeName">
      <el-tab-pane v-for="item in tabMapOptions" :label="item.name" :key='item.id' :name="item.code">
        <keep-alive>
          <tab-pane v-if='activeName==item.code' :type='item.id' :code="item.code"></tab-pane>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tabPane from './components/groupDetail'
import {
  getAllGroupTypes
} from '@/api/admin/group/index'
export default {
  name: 'group',
  components: {
    tabPane
  },
  data () {
    return {
      tabMapOptions: [
      ],
      activeName: 'role'
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
        this.tabMapOptions = [{"id":1,"code":"role","name":"角色管理","description":"role","updTime":"2017-08-26 01:52:37","updUser":"1","updName":"Mr.AG","updHost":"127.0.0.1"},{"id":2,"code":"depart","name":"部门管理","updTime":"2017-08-26 01:52:43","updUser":"1","updName":"Mr.AG","updHost":"127.0.0.1"}];
//
//      getAllGroupTypes().then(data => {
//          console.log("data:", JSON.stringify(data))
//        this.tabMapOptions = data;
//      })
    }
  }
}
</script>

<style scoped>
.tab-container {
  margin: 30px;
}
</style>
